import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const res = await login(email, password);
        setBusy(false);
        if (res.ok) {
            toast.success("Bienvenue à nouveau");
            navigate("/espace");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
            <div className="w-full max-w-md">
                <div className="text-sm tracking-[0.25em] uppercase text-primary mb-4 font-medium">Connexion</div>
                <h1 className="font-serif text-5xl mb-8">Bienvenue</h1>
                <form onSubmit={submit} className="space-y-6">
                    <div>
                        <Label htmlFor="email" className="mb-2 block">Email</Label>
                        <Input
                            id="email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="h-12 rounded-full px-5"
                            data-testid="login-email"
                        />
                    </div>
                    <div>
                        <Label htmlFor="password" className="mb-2 block">Mot de passe</Label>
                        <Input
                            id="password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="h-12 rounded-full px-5"
                            data-testid="login-password"
                        />
                    </div>
                    <Button
                        type="submit"
                        disabled={busy}
                        className="w-full h-12 rounded-full bg-primary text-primary-foreground"
                        data-testid="login-submit"
                    >
                        {busy ? "Connexion…" : "Se connecter"}
                    </Button>
                </form>
                <p className="mt-4 text-sm text-center">
                    <Link to="/mot-de-passe-oublie" className="text-muted-foreground underline underline-offset-4 hover:text-primary" data-testid="goto-forgot-password">
                        Mot de passe oublié ?
                    </Link>
                </p>
                <p className="mt-8 text-sm text-muted-foreground text-center">
                    Pas encore de compte ?{" "}
                    <Link to="/inscription" className="text-primary underline underline-offset-4" data-testid="goto-register">
                        Rejoindre la Foundation of Light
                    </Link>
                </p>
            </div>
        </div>
    );
}
